import React from 'react';

import Modal from '~/components/modals/modal';

import styles from '~/components/modals/grass-type/grass-type.module.scss';

const GrassTypeModal = ({ onClose, isOpen }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <Content />
    </Modal>
  );
};

const Content = () => (
  <div className={styles.grassTypesModal}>
    <h2>Help me choose</h2>
    <p>Choose "Other/Not sure" to get started right away.</p>
    <p>
      Our nutrients nourish every grass type, and are customized to your soil
      and climate with perfect timing. For now, we’ll show you at least one plan
      option that skips grass recommendations.
    </p>
    <img
      alt="People studying grass"
      src="/images/grass-types/modal-image.jpg"
    />
    <p>
      <strong>Need help later?</strong> Our Yard Advisors can identify your
      grass from a photo—just call, email, or text us. We've pre-selected the
      most common type for your region, but whether you have a single
      warm-season grass (like Bermuda) or a cool-season blend, we've got you
      covered.
    </p>
  </div>
);

export default GrassTypeModal;
